import React, { useEffect, useState } from 'react';
import { useI18n } from '../i18n/I18nProvider';
import { logAuthFailure, resolveAuthErrorMessage } from '../shared/utils/systemMessage';
import { userApi } from '../api/axios';
import { persistAccessToken, getStoredAccessToken } from '../api/authSession';
import { markBrowserAuthSession } from '../shared/utils/authPersistence';
import { clearGuestSpectatorSessionState } from '../shared/utils/guestSpectatorSession';

const NH_ORIGIN = String(process.env.REACT_APP_NIGHT_HOUSE_ORIGIN || '').trim().replace(/\/$/,'');
const TRY_KEY = 'nh:sso:auto-try';

function safeNext(next) {
  try {
    const url = new URL(next || '/lobby', window.location.origin);
    return url.origin === window.location.origin && url.pathname !== '/nh-sso' ? url.pathname+url.search : '/lobby';
  } catch (_) { return '/lobby'; }
}

// Only navigate when auto-SSO is configured. Stop loops on unauthenticated NH sessions.
export function NightHouseSsoAuto() {
  useEffect(() => {
    if (!/^https?:\/\//i.test(NH_ORIGIN)) return;
    const path=window.location.pathname;
    if (!(path==='/' || path==='/login' || path==='/lobby' || path.startsWith('/lobby/'))) return;
    if (window.location.search.includes('nh_sso=guest') || window.location.search.includes('guestLogin=1')) return;
    if (getStoredAccessToken()) return;
    const last = Number(sessionStorage.getItem(TRY_KEY) || 0);
    if (Date.now() - last < 5 * 60 * 1000) return;
    sessionStorage.setItem(TRY_KEY, String(Date.now()));
    const dest = new URL('/api/auth/sso/bridge', NH_ORIGIN);
    dest.searchParams.set('return_to', window.location.origin+window.location.pathname+window.location.search);
    window.location.replace(dest.toString());
  }, []);
  return null;
}

export function NightHouseSsoEntry() {
  const { t } = useI18n();
  const [errorCode, setErrorCode] = useState('');
  useEffect(() => {
    const fragment = new URLSearchParams(window.location.hash.slice(1));
    const code = fragment.get('code') || '';
    const next = safeNext(fragment.get('next'));
    // Immediately wipe the fragment from history.
    window.history.replaceState(null,'','/nh-sso');
    if (!code) {window.location.replace('/login?nh_sso=guest');return;}
    let cancelled = false;
    (async () => {
      try {
        const {data} = await userApi.post('/sso/night-house/redeem',{code},{__npcSkipAuthRefresh:true});
        if (cancelled) return;
        if (!data?.token || !data?.session_id) throw Error('Missing authentication session');
        clearGuestSpectatorSessionState({reason:'night_house_sso'});
        persistAccessToken(data.token,data.session_id);
        localStorage.removeItem('user_code');localStorage.removeItem('userCode');
        const u = data.user || {};
        localStorage.setItem('user',JSON.stringify({...u,user_code:String(u.user_code||''),User_code:String(u.user_code||'')}));
        markBrowserAuthSession({autoLogin:true});
        sessionStorage.removeItem(TRY_KEY);
        window.location.replace(next);
      } catch(e) {
        if(cancelled)return;
        // Show a localized code-based explanation, not raw backend messages
        // (which can reveal server configuration or internal diagnostics).
        const code = String(e?.response?.data?.error || '').trim().toUpperCase()
          || (e?.message === 'Missing authentication session' ? 'TOKEN_MISSING'
            : e?.response?.status >= 500 ? 'SSO_SERVICE_UNAVAILABLE'
              : e?.response ? 'SERVER_ERROR' : 'ERR_NETWORK');
        setErrorCode(code);
        logAuthFailure('night_house_sso', e);
      }
    })();
    return () => {cancelled=true;};
  }, []);
  const message = errorCode
    ? resolveAuthErrorMessage(t, { error: errorCode }, t('auth.login.error.failed', null, 'Login failed.'))
    : t('auth.login.sso.connecting', null, 'Connecting your Night House account…');
  return <main style={{minHeight:'100vh',background:'#090909',color:'#fff',display:'grid',placeItems:'center',fontFamily:'sans-serif',textAlign:'center',padding:30}}><div><h2>NIGHT HOUSE × NIGHT POKER CLUB</h2><p>{message}</p><a style={{color:'#f3bd74'}} href="/login?nh_sso=guest">{t('auth.login.sso.signInManually', null, 'Sign in manually')}</a></div></main>;
}
